export default __webpack_public_path__ + "static/media/checkViolet.a772a990.svg";